import Button from "components/ui/Button/Button";
import { useState } from "react";

const ErrorReport = ({ error, level, mail, phone }) => {
  const [ showInfo, setShowInfo ] = useState();

  const toggleInfoDisplay = event => {
    event.preventDefault();
    setShowInfo(() => !showInfo);
  }

  const handleSendMail = () => {
    const body = `Fout op pagina ${ window.location } (${ level } level) \n\n ${ error?.message } \n\n ${ error?.stack }`;
    window.location = encodeURI(`mailto:${ mail }?subject=Foutrapport uwtrefpunt.nl&body=${ body }`);
  }

  return (
    <>
      <h1>Er ging helaas iets mis...</h1>
      <h4>Probeer de pagina te verversen of wacht een paar minuten en probeer het dan
        opnieuw.</h4>
      <p>Blijft dit probleem bestaan? Neem dan contact op met onze helpdesk via <a
        href={ `mailto:${ mail }` }>{ mail }</a> of via telefoonnummer { phone }.</p>
      <p>De helpdesk is iedere werkdag bereikbaar van 09.00 tot 17.00 uur.</p>

      <p>
        <Button className={ `button--secondary error__button` } onClick={ () => window.location.reload() }>
          Ververs de pagina
        </Button>
        <Button className={ `button--primary error__button` } onClick={ handleSendMail }>
          Foutrapport mailen
        </Button>
      </p>
      <p>
        <button className={ `error__link-more` } onClick={ toggleInfoDisplay }>
          Foutrapport { showInfo ? `verbergen` : `weergeven` }
        </button>
      </p>

      {
        showInfo &&
        <div>
          <div className={ `error-detail` }>
            <h3 className={ `error-detail__title` }>Message</h3>
            { error?.message }
          </div>

          <div className={ `error-detail` }>
            <h3 className={ `error-detail__title` }>Stacktrace</h3>
            { error?.stack }
          </div>
        </div>
      }
    </>
  )
}

export default ErrorReport;
